/**
 * The colour options of the `farge` listing field (configListing.js).
 *
 * CommonJS, so the server (the partner-release job, which keeps the keyword
 * search text up to date) reads the same labels as the app.
 */
module.exports = [
  { option: 'sort', label: 'Sort' },
  { option: 'hvit', label: 'Hvit' },
  { option: 'offwhite', label: 'Offwhite' },
  { option: 'beige', label: 'Beige' },
  { option: 'brun', label: 'Brun' },
  { option: 'gra', label: 'Grå' },
  { option: 'bla', label: 'Blå' },
  { option: 'gronn', label: 'Grønn' },
  { option: 'gul', label: 'Gul' },
  { option: 'oransje', label: 'Oransje' },
  { option: 'rod', label: 'Rød' },
  { option: 'rosa', label: 'Rosa' },
  { option: 'lilla', label: 'Lilla' },
  { option: 'burgunder', label: 'Burgunder' },
  { option: 'solv', label: 'Sølv' },
  { option: 'gull', label: 'Gull' },
  { option: 'flerfarget', label: 'Flerfarget' },
];
